module.exports = __webpack_public_path__ + "img/itob_ctimg02.ebf83257.png";